import React from "react";
import Popov from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";
import Field from "../Field/Fi";
import { Link } from "@mui/material";

export default function Popover({ label, children }) {
  const [openedPopover, setOpenedPopover] = React.useState(false);
  const popoverAnchor = React.useRef(null);

  const popoverEnter = () => {
    setOpenedPopover(true);
  };

  const popoverLeave = () => {
    setOpenedPopover(false);
  };

  return (
    <div>
      <Typography
        aria-owns="mouse-over-popover"
        aria-haspopup="true"
        ref={popoverAnchor}
        onMouseEnter={popoverEnter}
        onMouseLeave={popoverLeave}
        fontSize="16px"
        fontWeight="600"
        variant="subtitle1"
        color="text.primary"
        sx={
          openedPopover
            ? {
                color: "#255CCE",
                paddingTop: "22px",
                paddingBottom: "20px",
                borderBottom: "2px solid #255CCE",
                cursor: "pointer",
              }
            : {
                paddingTop: "22px",
                paddingBottom: "22px",
              }
        }
      >
        {label}
      </Typography>
      <Popov
        id="mouse-over-popover"
        open={openedPopover}
        anchorEl={popoverAnchor.current}
        anchorPosition={{ left: 0 }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        marginThreshold={0}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
            pointerEvents: "auto",
          },
          onMouseEnter: popoverEnter,
          onMouseLeave: popoverLeave,
        }}
        sx={{
          pointerEvents: "none",
        }}
        disableRestoreFocus
      >
        <Container
          disableGutters={true}
          sx={{
            padding: { sm: "1.625rem 2rem", md: "1.625rem 0" },
            marginLeft: { sm: "auto", md: "32px", lg: "235px" },
          }}
        >
          {children}
        </Container>
      </Popov>
    </div>
  );
}

export function Heading({ children }) {
  return (
    <Container
      disableGutters={true}
      sx={{
        display: "flex",
        alignItems: "center",
        color: "#255CCE",
        "&:hover": {
          cursor: "pointer",
        },
      }}
    >
      <Typography
        variant="subtitle2"
        fontWeight="600"
        fontSize="14px"
        lineHeight="20px"
      >
        {children}
      </Typography>
      <ChevronRightIcon />
    </Container>
  );
}

export function Details({ label, content }) {
  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "auto",
        margin: "0",
      }}
    >
      <Heading>{label}</Heading>
      <Box sx={{ height: "10px" }} />
      {content.map((c) => (
        <Typography
          sx={{
            "&:hover": {
              color: "#255CCE",
              cursor: "pointer",
            },
          }}
          variant="body2"
          fontWeight="400"
          fontSize="14px"
          color="text.primary"
          lineHeight="20px"
        >
          {c}
        </Typography>
      ))}
    </Container>
  );
}

export function SearchArea() {
  const [val, setVal] = React.useState("");
  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "auto",
        margin: "0",
      }}
    >
      <Field
        label="Search by category"
        labelVariant="body2"
        labelFont="14px"
        size="small"
        sx={{
          "& .MuiOutlinedInput-root": {
            padding: "0px",
          },
          width: { sm: "250px", md: "326px" },
          height: "38.14px",
        }}
        endIcon={<SearchIcon sx={{ color: "#808080", marginRight: "8px" }} />}
        borderColor="#BFBFBF"
        labelStyle={{ color: "#616161" }}
        labelColor="#616161"
        value={val}
        handleChange={({ target }) => setVal(target.value)}
        transform="translate(7px,7px)"
      ></Field>
      <Box sx={{ height: "45px" }} />
      <Typography
        variant="caption"
        fontWeight="400"
        fontSize="12px"
        lineHeight="16px"
        color="#616161"
        sx={{ marginBottom: "8px" }}
      >
        QUICK LINKS
      </Typography>
      <Link
        href="#"
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="primary.main"
        sx={{
          marginBottom: "8px",
          textDecoration: "none",
          "&:hover": {
            color: "#4420A1",
          },
        }}
      >
        Explore all machinery for Buy
      </Link>
      <Link
        href="#"
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="#255CCE"
        sx={{
          marginBottom: "8px",
          textDecoration: "none",
          "&:hover": {
            color: "#4420A1",
          },
        }}
      >
        Explore all machinery for Auction
      </Link>
      <Link
        href="#"
        variant="body2"
        fontWeight="400"
        fontSize="14px"
        lineHeight="20px"
        color="#255CCE"
        sx={{
          marginBottom: "8px",
          textDecoration: "none",
          "&:hover": {
            color: "#4420A1",
          },
        }}
      >
        Explore all Pro machinery
      </Link>
    </Container>
  );
}
